// 各模块模拟数据(key 与 src/config/modules.js 中模块 key 一一对应)
// 后期接入后端时,本文件可整体删除,由 src/api/index.js 改为真实接口请求

export const mockDb = {
  farm: [
    { houseNo: 'JS-001', area: 320, chickenCount: 1500, cleanStatus: '良好', temperature: 22.5, humidity: 58, ventilation: '正常', lighting: '正常', feedUse: '每日两顿,采食量正常', medicineUse: '本周无用药' },
    { houseNo: 'JS-002', area: 280, chickenCount: 1200, cleanStatus: '一般', temperature: 24.1, humidity: 62, ventilation: '正常', lighting: '偏弱', feedUse: '每日一顿,采食量良好', medicineUse: '添加多维素' },
    { houseNo: 'JS-003', area: 350, chickenCount: 1800, cleanStatus: '优秀', temperature: 21.8, humidity: 55, ventilation: '增强', lighting: '正常', feedUse: '每日两顿,采食量正常', medicineUse: '无' },
    { houseNo: 'JS-004', area: 300, chickenCount: 1350, cleanStatus: '良好', temperature: 23.0, humidity: 60, ventilation: '正常', lighting: '正常', feedUse: '每日两顿,略有剩余', medicineUse: '预防投药中' },
    { houseNo: 'JS-005', area: 260, chickenCount: 980, cleanStatus: '差', temperature: 26.3, humidity: 70, ventilation: '不足', lighting: '正常', feedUse: '采食量下降', medicineUse: '治疗用药:大肠杆菌药' }
  ],
  feed: [
    { feedName: '肉鸡浓缩料', spec: '40kg/袋', factory: '正大集团', price: 168.0, usage: '120kg/天', stock: 860, inTime: '2026-09-01', expireTime: '2027-03-01', outTime: '2026-09-20', remark: '育肥期主力料' },
    { feedName: '蛋鸡预混料', spec: '25kg/袋', factory: '新希望六和', price: 132.0, usage: '80kg/天', stock: 420, inTime: '2026-08-15', expireTime: '2027-02-15', outTime: '2026-09-18', remark: '' },
    { feedName: '玉米粉碎料', spec: '50kg/袋', factory: '绿源饲料厂', price: 98.0, usage: '200kg/天', stock: 1500, inTime: '2026-09-10', expireTime: '2026-12-10', outTime: '2026-09-25', remark: '注意防潮' },
    { feedName: '雏鸡破碎料', spec: '20kg/袋', factory: '正大集团', price: 115.0, usage: '35kg/天', stock: 260, inTime: '2026-09-05', expireTime: '2027-01-05', outTime: '2026-09-22', remark: '1-21日龄使用' },
    { feedName: '麸皮饲料', spec: '30kg/袋', factory: '牧丰科技', price: 55.0, usage: '45kg/天', stock: 300, inTime: '2026-07-20', expireTime: '2026-11-20', outTime: '2026-09-12', remark: '库存偏少,待补货' }
  ],
  medicine: [
    { medicineName: '硫酸黏菌素可溶性粉', spec: '100g/包', factory: '中农兽药', price: 36.0, usage: '拌料,连用5天', stock: 120, inTime: '2026-08-01', expireTime: '2028-08-01', outTime: '2026-09-15', remark: '肠道疾病治疗' },
    { medicineName: '电解多维', spec: '500g/包', factory: '格瑞药业', price: 45.0, usage: '饮水,长期补充', stock: 80, inTime: '2026-09-03', expireTime: '2028-09-03', outTime: '2026-09-20', remark: '抗应激' },
    { medicineName: '氟苯尼考注射液', spec: '10ml/支', factory: '生物药业', price: 8.5, usage: '肌注,0.1ml/kg', stock: 260, inTime: '2026-07-15', expireTime: '2027-07-15', outTime: '2026-09-10', remark: '呼吸道感染备用' },
    { medicineName: '黄芪多糖粉', spec: '100g/包', factory: '中农兽药', price: 28.0, usage: '饮水,提高免疫', stock: 150, inTime: '2026-09-08', expireTime: '2028-09-08', outTime: '2026-09-24', remark: '' },
    { medicineName: '碘制剂消毒剂', spec: '5kg/桶', factory: '康达消毒', price: 68.0, usage: '带鸡消毒1:500', stock: 22, inTime: '2026-08-25', expireTime: '2027-08-25', outTime: '2026-09-26', remark: '每周二、六使用' }
  ],
  purchase: [
    { orderNo: 'CG20260901001', purchaseDate: '2026-09-01', supplier: '正大集团', goods: '肉鸡浓缩料', quantity: 100, amount: 16800.0, handler: '张三', remark: '月度大宗采购' },
    { orderNo: 'CG20260908002', purchaseDate: '2026-09-08', supplier: '中农兽药', goods: '兽药一批', quantity: 50, amount: 3200.0, handler: '李四', remark: '含黏菌素、电解多维' },
    { orderNo: 'CG20260912003', purchaseDate: '2026-09-12', supplier: '牧丰科技', goods: '麸皮饲料', quantity: 60, amount: 3300.0, handler: '张三', remark: '' },
    { orderNo: 'CG20260920004', purchaseDate: '2026-09-20', supplier: '兴业包装厂', goods: '蛋托包装', quantity: 2000, amount: 1800.0, handler: '王五', remark: '鸡蛋销售包装' },
    { orderNo: 'CG20260925005', purchaseDate: '2026-09-25', supplier: '华农设备', goods: '环控风机', quantity: 4, amount: 5600.0, handler: '赵六', remark: '3号舍通风改造' }
  ],
  production: [
    { hatchDate: '2026-08-01', hatchType: '白羽肉鸡', hatchCount: 3000, successRate: '92.5%', health: '良好', saleStatus: '待售', feeding: '正常', immune: '已免疫', disease: '无', handleWay: '正常饲养' },
    { hatchDate: '2026-08-15', hatchType: '罗曼蛋鸡', hatchCount: 2000, successRate: '89.0%', health: '优秀', saleStatus: '部分销售', feeding: '正常', immune: '已免疫', disease: '无', handleWay: '分舍饲养' },
    { hatchDate: '2026-09-01', hatchType: '麻鸡', hatchCount: 1500, successRate: '85.2%', health: '良好', saleStatus: '待售', feeding: '正常', immune: '待免疫', disease: '无', handleWay: '加强保温' },
    { hatchDate: '2026-09-10', hatchType: '817肉杂', hatchCount: 2500, successRate: '78.6%', health: '一般', saleStatus: '待售', feeding: '略差', immune: '已免疫', disease: '个别呼吸道症状', handleWay: '隔离观察+投药' },
    { hatchDate: '2026-09-20', hatchType: '三黄鸡', hatchCount: 1800, successRate: '91.3%', health: '良好', saleStatus: '待售', feeding: '正常', immune: '已免疫', disease: '无', handleWay: '正常饲养' }
  ],
  sales: [
    { orderNo: 'XS20260905001', saleDate: '2026-09-05', customer: '城东农贸市场', goods: '肉鸡', quantity: 500, amount: 15000.0, handler: '孙七', remark: '活禽批发' },
    { orderNo: 'XS20260912002', saleDate: '2026-09-12', customer: '绿源食品公司', goods: '鸡蛋', quantity: 3000, amount: 18600.0, handler: '王五', remark: '整托发货' },
    { orderNo: 'XS20260918003', saleDate: '2026-09-18', customer: '老李土特产店', goods: '土鸡蛋', quantity: 800, amount: 7200.0, handler: '孙七', remark: '' },
    { orderNo: 'XS20260924004', saleDate: '2026-09-24', customer: 'KW餐饮集团', goods: '三黄鸡', quantity: 300, amount: 10500.0, handler: '张三', remark: '月结' },
    { orderNo: 'XS20260928005', saleDate: '2026-09-28', customer: '城北超市', goods: '鸡蛋', quantity: 1500, amount: 9300.0, handler: '王五', remark: '促销活动供货' }
  ],
  warehouse: [
    { goodsName: '肉鸡浓缩料', quantity: 100, ioFlag: '入库', ioTime: '2026-09-01 08:30', handler: '张三', remark: '采购单CG20260901001' },
    { goodsName: '豆粕饲料', quantity: 20, ioFlag: '出库', ioTime: '2026-09-10 14:20', handler: '李四', remark: '2号舍领用' },
    { goodsName: '电解多维', quantity: 30, ioFlag: '入库', ioTime: '2026-09-03 10:00', handler: '李四', remark: '' },
    { goodsName: '鸡蛋', quantity: 3000, ioFlag: '出库', ioTime: '2026-09-12 07:50', handler: '王五', remark: '销售出库XS20260912002' },
    { goodsName: '氟苯尼考注射液', quantity: 100, ioFlag: '出库', ioTime: '2026-09-10 16:40', handler: '赵六', remark: '5号舍治疗领用' },
    { goodsName: '蛋托包装', quantity: 2000, ioFlag: '入库', ioTime: '2026-09-20 09:10', handler: '王五', remark: '' }
  ],
  check: [
    { checkTime: '2026-09-28 07:30', checkItem: '鸡舍饲料余量', checkResult: '正常', handleStatus: '无需处理', recorder: '张三' },
    { checkTime: '2026-09-28 09:00', checkItem: '饮水系统', checkResult: '异常', handleStatus: '更换3号舍乳头饮水器2个', recorder: '李四' },
    { checkTime: '2026-09-27 16:00', checkItem: '鸡群精神状态', checkResult: '正常', handleStatus: '', recorder: '王五' },
    { checkTime: '2026-09-27 08:00', checkItem: '通风设备', checkResult: '异常', handleStatus: '5号舍风机皮带松动,已报修', recorder: '赵六' },
    { checkTime: '2026-09-26 15:30', checkItem: '消毒执行情况', checkResult: '正常', handleStatus: '', recorder: '孙七' },
    { checkTime: '2026-09-26 07:45', checkItem: '死淘记录', checkResult: '正常', handleStatus: '无异常死亡', recorder: '张三' }
  ],
  vaccine: [
    { vaccineName: '新城疫IV系疫苗', spec: '500羽/瓶', validDate: '2027-05-01', factory: '中农生物', dosage: '滴鼻点眼', injectTime: '2026-09-20 08:00', injectPart: '眼结膜', immuneStatus: '良好', handler: '李四' },
    { vaccineName: '禽流感H9二价苗', spec: '250ml/瓶', validDate: '2027-03-15', factory: '乾瑞生物', dosage: '0.5ml/羽', injectTime: '2026-09-15 07:30', injectPart: '颈部皮下', immuneStatus: '良好', handler: '赵六' },
    { vaccineName: '传支H120疫苗', spec: '1000羽/瓶', validDate: '2027-01-20', factory: '中农生物', dosage: '饮水', injectTime: '2026-09-08 07:00', injectPart: '饮水免疫', immuneStatus: '一般', handler: '李四' },
    { vaccineName: '禽痘疫苗', spec: '1000羽/瓶', validDate: '2026-12-10', factory: '生物药业', dosage: '翅膜刺种', injectTime: '2026-08-25 08:30', injectPart: '翅膜', immuneStatus: '良好', handler: '王五' },
    { vaccineName: '减蛋综合征苗', spec: '250ml/瓶', validDate: '2027-06-30', factory: '乾瑞生物', dosage: '0.5ml/羽', injectTime: '2026-08-10 07:30', injectPart: '胸部肌肉', immuneStatus: '良好', handler: '赵六' }
  ],
  egg: [
    { eggNo: 'DD20260928-01', layTime: '2026-09-28 06:40', houseNo: 'JS-006', storeTime: '2026-09-28 08:00', saleStatus: '待售', qualityCheck: '合格', handler: '张三' },
    { eggNo: 'DD20260928-02', layTime: '2026-09-28 07:10', houseNo: 'JS-007', storeTime: '2026-09-28 08:20', saleStatus: '已售', qualityCheck: '合格', handler: '王五' },
    { eggNo: 'DD20260927-03', layTime: '2026-09-27 06:55', houseNo: 'JS-006', storeTime: '2026-09-27 08:00', saleStatus: '已售', qualityCheck: '合格', handler: '王五' },
    { eggNo: 'DD20260927-04', layTime: '2026-09-27 07:30', houseNo: 'JS-008', storeTime: '2026-09-27 09:00', saleStatus: '待售', qualityCheck: '待检', handler: '李四' },
    { eggNo: 'DD20260926-05', layTime: '2026-09-26 06:20', houseNo: 'JS-007', storeTime: '2026-09-26 08:10', saleStatus: '已售', qualityCheck: '不合格', handler: '赵六' }
  ],
  breed: [
    { orderNo: 'GMD20260901001', buyDate: '2026-09-01', breedType: '罗曼蛋鸡父母代', quantity: 500, price: 45.0, supplier: '中禽育种公司', handler: '张三', remark: '产蛋性能好' },
    { orderNo: 'GMD20260910002', buyDate: '2026-09-10', breedType: 'AA肉鸡种鸡', quantity: 300, price: 52.0, supplier: '益生种禽', handler: '李四', remark: '' },
    { orderNo: 'GMD20260915003', buyDate: '2026-09-15', breedType: '麻鸡种鸡', quantity: 400, price: 38.0, supplier: '民望禽业', handler: '王五', remark: '含15羽公鸡' },
    { orderNo: 'GMD20260922004', buyDate: '2026-09-22', breedType: '三黄胡须鸡', quantity: 260, price: 41.5, supplier: '穗星育种', handler: '赵六', remark: '地方特色品种' },
    { orderNo: 'GMD20260926005', buyDate: '2026-09-26', breedType: '芦花鸡', quantity: 350, price: 36.0, supplier: '绿源珍禽', handler: '孙七', remark: '散养系' }
  ],
  clean: [
    { cleanTime: '2026-09-28 06:00', houseNo: 'JS-001', cleanStatus: '优秀', cleaner: '周大娘', remark: '清粪+消毒' },
    { cleanTime: '2026-09-27 06:10', houseNo: 'JS-002', cleanStatus: '良好', cleaner: '吴大姐', remark: '更换垫料' },
    { cleanTime: '2026-09-26 06:00', houseNo: 'JS-003', cleanStatus: '优秀', cleaner: '周大娘', remark: '' },
    { cleanTime: '2026-09-25 06:20', houseNo: 'JS-004', cleanStatus: '一般', cleaner: '郑师傅', remark: '排水沟略有堵塞,已疏通' },
    { cleanTime: '2026-09-24 06:00', houseNo: 'JS-005', cleanStatus: '良好', cleaner: '吴大姐', remark: '带鸡消毒' }
  ],
  slaughter: [
    { date: '2026-09-27', slaughterCount: 200, productCount: 310.5, wasteCount: 42.3, worker: '马师傅', handler: '张三' },
    { date: '2026-09-24', slaughterCount: 150, productCount: 232.0, wasteCount: 31.5, worker: '杨师傅', handler: '李四' },
    { date: '2026-09-21', slaughterCount: 260, productCount: 405.8, wasteCount: 55.2, worker: '马师傅', handler: '张三' },
    { date: '2026-09-18', slaughterCount: 120, productCount: 186.4, wasteCount: 24.0, worker: '艾师傅', handler: '王五' },
    { date: '2026-09-15', slaughterCount: 300, productCount: 468.0, wasteCount: 61.7, worker: '马师傅', handler: '赵六' }
  ],
  cost: [
    { feedCost: 52000.0, medicineCost: 6800.0, transportCost: 3500.0, laborCost: 21000.0, deviceCost: 4200.0, otherCost: 1500.0, totalCost: 89000.0, remark: '2026年9月' },
    { feedCost: 49800.0, medicineCost: 5200.0, transportCost: 3100.0, laborCost: 21000.0, deviceCost: 4200.0, otherCost: 2300.0, totalCost: 85600.0, remark: '2026年8月' },
    { feedCost: 51200.0, medicineCost: 8900.0, transportCost: 4000.0, laborCost: 20000.0, deviceCost: 4200.0, otherCost: 1100.0, totalCost: 89400.0, remark: '2026年7月' },
    { feedCost: 47600.0, medicineCost: 4300.0, transportCost: 2800.0, laborCost: 20000.0, deviceCost: 3800.0, otherCost: 900.0, totalCost: 79400.0, remark: '2026年6月' },
    { feedCost: 46200.0, medicineCost: 5600.0, transportCost: 3300.0, laborCost: 20000.0, deviceCost: 3800.0, otherCost: 1400.0, totalCost: 80300.0, remark: '2026年5月' }
  ]
}

// 统计报表模拟数据(key 为报表路由 path 最后一段)
export const mockReports = {
  sales: {
    title: '销售报表',
    summary: [
      { label: '本月销售额(元)', value: 60600 },
      { label: '本月销售单数', value: 5 },
      { label: '销售只数/斤合计', value: 6100 },
      { label: '月环比增长', value: '8.6%' }
    ],
    rows: [
      { period: '2026-05', saleAmount: 45200, orderCount: 4, topGoods: '鸡蛋', avgPrice: '9.8元/斤' },
      { period: '2026-06', saleAmount: 51800, orderCount: 5, topGoods: '肉鸡', avgPrice: '30.5元/只' },
      { period: '2026-07', saleAmount: 55300, orderCount: 5, topGoods: '鸡蛋', avgPrice: '6.2元/斤' },
      { period: '2026-08', saleAmount: 57900, orderCount: 6, topGoods: '土鸡蛋', avgPrice: '9.0元/斤' },
      { period: '2026-09', saleAmount: 60600, orderCount: 5, topGoods: '鸡蛋', avgPrice: '6.2元/斤' }
    ],
    columns: [
      { prop: 'period', label: '统计周期' },
      { prop: 'saleAmount', label: '销售额(元)' },
      { prop: 'orderCount', label: '销售单数' },
      { prop: 'topGoods', label: '热销品类' },
      { prop: 'avgPrice', label: '均价' }
    ]
  },
  stock: {
    title: '库存报表',
    summary: [
      { label: '饲料库存(kg)', value: 3340 },
      { label: '药品库存(件)', value: 632 },
      { label: '疫苗库存(瓶)', value: 5 },
      { label: '临期物品', value: 2 }
    ],
    rows: [
      { period: '饲料', stockQty: 3340, stockAmount: 28600, warnCount: 1, turnover: '月度12次' },
      { period: '药品', stockQty: 632, stockAmount: 9800, warnCount: 0, turnover: '月度6次' },
      { period: '疫苗', stockQty: 5, stockAmount: 2300, warnCount: 1, turnover: '月度2次' },
      { period: '包装物', stockQty: 2000, stockAmount: 1800, warnCount: 0, turnover: '月度4次' }
    ],
    columns: [
      { prop: 'period', label: '库存类别' },
      { prop: 'stockQty', label: '库存数量' },
      { prop: 'stockAmount', label: '库存金额(元)' },
      { prop: 'warnCount', label: '预警项数' },
      { prop: 'turnover', label: '周转频次' }
    ]
  },
  io: {
    title: '进出库报表',
    summary: [
      { label: '本月入库单数', value: 4 },
      { label: '本月出库单数', value: 3 },
      { label: '入库总量', value: 2130 },
      { label: '出库总量', value: 3140 }
    ],
    rows: [
      { period: '2026-05', inQty: 2600, outQty: 2100, diff: 500 },
      { period: '2026-06', inQty: 3100, outQty: 2800, diff: 300 },
      { period: '2026-07', inQty: 2400, outQty: 2600, diff: -200 },
      { period: '2026-08', inQty: 3300, outQty: 2900, diff: 400 },
      { period: '2026-09', inQty: 2130, outQty: 3140, diff: -1010 }
    ],
    columns: [
      { prop: 'period', label: '统计周期' },
      { prop: 'inQty', label: '入库数量' },
      { prop: 'outQty', label: '出库数量' },
      { prop: 'diff', label: '净增减' }
    ]
  },
  finance: {
    title: '财务报表',
    summary: [
      { label: '本月收入(元)', value: 60600 },
      { label: '本月支出(元)', value: 89000 },
      { label: '本月净利润(元)', value: -28400 },
      { label: '累计净利润(元)', value: 126800 }
    ],
    rows: [
      { period: '2026-05', income: 45200, expense: 80300, profit: -35100 },
      { period: '2026-06', income: 51800, expense: 79400, profit: -27600 },
      { period: '2026-07', income: 55300, expense: 89400, profit: -34100 },
      { period: '2026-08', income: 57900, expense: 85600, profit: -27700 },
      { period: '2026-09', income: 60600, expense: 89000, profit: -28400 }
    ],
    columns: [
      { prop: 'period', label: '统计周期' },
      { prop: 'income', label: '收入(元)' },
      { prop: 'expense', label: '支出(元)' },
      { prop: 'profit', label: '利润(元)' }
    ]
  },
  disease: {
    title: '疾病报表',
    summary: [
      { label: '本月发病批次', value: 2 },
      { label: '治愈批次', value: 1 },
      { label: '死亡只数', value: 35 },
      { label: '发病率', value: '0.9%' }
    ],
    rows: [
      { period: '2026-05', caseCount: 1, deathCount: 8, disease: '大肠杆菌', cureRate: '100%' },
      { period: '2026-06', caseCount: 0, deathCount: 3, disease: '无', cureRate: '-' },
      { period: '2026-07', caseCount: 2, deathCount: 21, disease: '新城疫', cureRate: '85%' },
      { period: '2026-08', caseCount: 1, deathCount: 12, disease: '呼吸道综合征', cureRate: '92%' },
      { period: '2026-09', caseCount: 2, deathCount: 35, disease: '大肠杆菌/呼吸道', cureRate: '78%' }
    ],
    columns: [
      { prop: 'period', label: '统计周期' },
      { prop: 'caseCount', label: '发病批次' },
      { prop: 'deathCount', label: '死亡只数' },
      { prop: 'disease', label: '主要疾病' },
      { prop: 'cureRate', label: '治愈率' }
    ]
  },
  production: {
    title: '生产报表',
    summary: [
      { label: '本月孵化批次', value: 3 },
      { label: '孵化总量(只)', value: 5800 },
      { label: '平均成功率', value: '85.0%' },
      { label: '成活率', value: '96.2%' }
    ],
    rows: [
      { period: '2026-05', hatchCount: 4200, successRate: '88.1%', aliveRate: '95.8%' },
      { period: '2026-06', hatchCount: 5100, successRate: '90.3%', aliveRate: '96.5%' },
      { period: '2026-07', hatchCount: 4600, successRate: '86.9%', aliveRate: '95.2%' },
      { period: '2026-08', hatchCount: 6500, successRate: '90.6%', aliveRate: '97.0%' },
      { period: '2026-09', hatchCount: 5800, successRate: '85.0%', aliveRate: '96.2%' }
    ],
    columns: [
      { prop: 'period', label: '统计周期' },
      { prop: 'hatchCount', label: '孵化数量(只)' },
      { prop: 'successRate', label: '孵化成功率' },
      { prop: 'aliveRate', label: '成活率' }
    ]
  },
  business: {
    title: '经营报表',
    summary: [
      { label: '营业总收入(元)', value: 270800 },
      { label: '营业总成本(元)', value: 423700 },
      { label: '毛利率', value: '32.5%' },
      { label: '客户总数', value: 18 }
    ],
    rows: [
      { period: '2026-Q1', revenue: 152000, cost: 210000, grossRate: '30.1%' },
      { period: '2026-Q2', revenue: 181000, cost: 236000, grossRate: '31.6%' },
      { period: '2026-Q3', revenue: 270800, cost: 245000, grossRate: '32.5%' },
      { period: '全年预计', revenue: 603800, cost: 691000, grossRate: '33.0%' }
    ],
    columns: [
      { prop: 'period', label: '统计周期' },
      { prop: 'revenue', label: '营业收入(元)' },
      { prop: 'cost', label: '营业成本(元)' },
      { prop: 'grossRate', label: '毛利率' }
    ]
  },
  health: {
    title: '健康报表',
    summary: [
      { label: '在群只数', value: 6830 },
      { label: '健康占比', value: '97.2%' },
      { label: '亚健康占比', value: '2.3%' },
      { label: '发病占比', value: '0.5%' }
    ],
    rows: [
      { period: 'JS-001', total: 1500, healthy: 1472, sick: 12, rate: '98.1%' },
      { period: 'JS-002', total: 1200, healthy: 1168, sick: 15, rate: '97.3%' },
      { period: 'JS-003', total: 1800, healthy: 1766, sick: 9, rate: '98.1%' },
      { period: 'JS-004', total: 1350, healthy: 1305, sick: 18, rate: '96.7%' },
      { period: 'JS-005', total: 980, healthy: 923, sick: 25, rate: '94.2%' }
    ],
    columns: [
      { prop: 'period', label: '鸡舍' },
      { prop: 'total', label: '存栏只数' },
      { prop: 'healthy', label: '健康只数' },
      { prop: 'sick', label: '发病只数' },
      { prop: 'rate', label: '健康率' }
    ]
  },
  yield: {
    title: '亩产报表',
    summary: [
      { label: '养殖面积(亩)', value: 12.6 },
      { label: '本月只均产出(元)', value: 8.9 },
      { label: '斤蛋成本(元)', value: 4.1 },
      { label: '亩均产值(元)', value: 4820 }
    ],
    rows: [
      { period: '鸡舍面积', value: 2610, unit: '㎡', rate: '-' },
      { period: '蛋鸡产蛋率', value: 91.2, unit: '%', rate: '+1.3%' },
      { period: '肉鸡料肉比', value: 1.65, unit: ':1', rate: '-0.04' },
      { period: '亩均产蛋量', value: 3120, unit: 'kg', rate: '+3.6%' },
      { period: '亩均产值', value: 4820, unit: '元', rate: '+5.2%' }
    ],
    columns: [
      { prop: 'period', label: '指标项' },
      { prop: 'value', label: '本期值' },
      { prop: 'unit', label: '单位' },
      { prop: 'rate', label: '环比' }
    ]
  },
  marketing: {
    title: '营销报表',
    summary: [
      { label: '客户总数', value: 18 },
      { label: '本月新增客户', value: 3 },
      { label: '复购率', value: '68.0%' },
      { label: '大客户占比', value: '42.0%' }
    ],
    rows: [
      { period: '城东农贸市场', customer: '批发商', amount: 15000, proportion: '24.8%' },
      { period: '绿源食品公司', customer: '企业客户', amount: 18600, proportion: '30.7%' },
      { period: '老李土特产店', customer: '零售门店', amount: 7200, proportion: '11.9%' },
      { period: 'KW餐饮集团', customer: '餐饮集团', amount: 10500, proportion: '17.3%' },
      { period: '城北超市', customer: '商超', amount: 9300, proportion: '15.3%' }
    ],
    columns: [
      { prop: 'period', label: '渠道/客户' },
      { prop: 'customer', label: '客户类型' },
      { prop: 'amount', label: '本月销售额(元)' },
      { prop: 'proportion', label: '占比' }
    ]
  }
}
